import { render, staticRenderFns } from "./DevideStatus.vue?vue&type=template&id=1640d551&scoped=true&"
import script from "./DevideStatus.vue?vue&type=script&lang=js&"
export * from "./DevideStatus.vue?vue&type=script&lang=js&"
import style0 from "./DevideStatus.vue?vue&type=style&index=0&id=1640d551&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640d551",
  null
  
)

export default component.exports